import axios from "axios";
import { EventEmitter } from "eventemitter3";

export default class AbortUploadService extends EventEmitter {
  constructor(url, headers) {
    super();
    this.url = url;
    this.headers = headers || {};
  }

  execute(fileId, uploadId) {
    return new Promise((resolve, reject) => {
      const { url, headers } = this;
      const data = { fileId, uploadId };
      axios
        .post(url, data, { headers })
        .then((e) => {
          if (e.data.code !== 200) {
            return reject(new Error(e.data.message));
          }
          resolve();
        })
        .catch((err) => reject(err));
    });
  }
}
